import Vue from 'vue'

export const loaderState = Vue.observable({ active: false })

export function showLoader () { loaderState.active = true }
export function hideLoader () { loaderState.active = false }

export async function withLoader (fn) {
  showLoader()
  try {
    return await fn()
  } finally {
    hideLoader()
  }
}
